import LucideIcon from '@/src/components/atom/Icons/LucideIcon';
import { UNIT_STRINGS } from '@/src/constants/unit';
import {
  createDateHasAllTimeCol,
  createDetailButtonColV2,
  createIdCol,
  createIndexCol,
  createNumberCol,
  createPhoneCol,
  createTypoCol,
} from '@/src/helpers/agColumnHelper';
import { formatter } from '@/src/utils/formatter';
import {
  ColDef,
  ICellRendererParams,
  ValueGetterParams,
} from 'ag-grid-community';
import dayjs from 'dayjs';

export const partnershipLinkListColumn = ({
  handleUrlClick,
  onDetailClick,
}: {
  handleUrlClick: (text: string) => void;
  onDetailClick: (id: number) => void;
}): ColDef[] => [
  createIdCol(),
  createDateHasAllTimeCol({
    field: 'postedAt',
    size: 'lg',
    cellRenderer: (params: ValueGetterParams) => {
      return `${dayjs(params?.data?.startedAt).format('YYYY-MM-DD')} ~ ${dayjs(params?.data?.endedAt).format('YYYY-MM-DD')}`;
    },
    headerName: '게시 기간',
  }),
  createTypoCol({
    field: 'name',
    size: 'sm',
    cellRenderer: (params: ValueGetterParams) => {
      return params?.data?.partnershipCompany.name;
    },
    headerName: '제휴사 명',
  }),
  createTypoCol({
    field: 'urlCode',
    size: 'lg',
    cellRenderer: ({ data }: ICellRendererParams) => {
      const isProd = process.env.REACT_APP_ENV_MODE === 'prod';
      return (
        <div
          className="m-auto flex w-max items-center justify-center gap-[6px]"
          onClick={() => data.urlCode && handleUrlClick(data.urlCode)}
        >
          {isProd
            ? `https://partners.ecoyaearth.com/${data.urlCode}`
            : `https://dev-partners.ecoyaearth.com/${data.urlCode}` || '-'}
          {data.urlCode && <LucideIcon name="Copy" size={14} color="gray9" />}
        </div>
      );
    },
    headerName: '생성된 URL',
  }),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '등록 일자',
  }),
  createTypoCol({
    field: 'administrator',
    size: 'sm',
    cellRenderer: (params: ValueGetterParams) => {
      return params?.data?.administrator.name;
    },
    headerName: '등록 관리자',
  }),
  createDetailButtonColV2(onDetailClick),
];

export const PartnerParticipantListColumn: ColDef[] = [
  createIndexCol(),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '가입 일시',
  }),
  createTypoCol({
    field: 'nick',
    size: 'sm',
    headerName: '닉네임',
  }),
  createTypoCol({
    field: 'name',
    size: 'sm',
    headerName: '이름',
  }),
  createPhoneCol({
    field: 'phone',
    size: 'sm',
    headerName: '핸드폰 번호',
  }),
  createTypoCol({
    field: 'customerAddress',
    headerName: '주소',
    size: 'lg',
    flex: 2,
  }),
  createNumberCol({
    field: 'totalDeposit',
    headerName: '지급 크레딧',
    cellRenderer: ({ value }: ICellRendererParams) => {
      return `${formatter.NUM_COMMA(Math.abs(value || 0))}${UNIT_STRINGS.CREDIT}`;
    },
    size: 'sm',
  }),
  createNumberCol({
    field: 'totalUsage',
    headerName: '사용 크레딧',
    cellRenderer: ({ value }: ICellRendererParams) => {
      return `${formatter.NUM_COMMA(Math.abs(value || 0))}${UNIT_STRINGS.CREDIT}`;
    },
    size: 'sm',
  }),
];
